import React from 'react';
import styles from './styles.module.css';

const AddressCard = ({ address }) => {
  const addressName = address.name ? address.name : false;
  return (
    <div className={`${styles.box_container} drop-shadow`}>
      {addressName && <p className={styles.addressName}>{addressName}</p>}
      <p className={styles.addressText}>{address.address_line1}</p>
      <p className={styles.addressText}>{address.address_line2}</p>
      <p className={styles.addressText}>{address.address_line3}</p>
      <p className={styles.addressText}>{address.address_line4}</p>
      <p className={styles.addressText}>{address.postcode}</p>
    </div>
  );
};

export default AddressCard;
